import { OktaAuth, type AuthState } from "@okta/okta-auth-js";

const issuer = import.meta.env.VITE_OKTA_ISSUER?.trim();
const clientId = import.meta.env.VITE_OKTA_CLIENT_ID?.trim();
export const audience = import.meta.env.VITE_OKTA_AUDIENCE?.trim();

export const configured = Boolean(
  issuer && clientId && audience &&
  !issuer.includes("replace-with") &&
  !clientId.includes("replace-with") &&
  !audience.includes("replace-with"),
);

export const authClient = configured
  ? new OktaAuth({
      issuer: issuer!,
      clientId: clientId!,
      redirectUri: `${window.location.origin}/login/callback`,
      postLogoutRedirectUri: window.location.origin,
      scopes: ["openid", "profile", "email", "groups"],
      pkce: true,
      tokenManager: {
        storage: "sessionStorage",
        storageKey: "people-team-offsite-okta-org-v2",
        autoRenew: true,
        expireEarlySeconds: 30,
      },
      storageManager: {
        token: { storageType: "sessionStorage", storageKey: "people-team-offsite-okta-org-v2" },
        transaction: { storageType: "sessionStorage" },
        originalUri: { storageType: "sessionStorage" },
      },
    })
  : null;

export async function initializeAuth(onState: (state: AuthState) => void) {
  if (!authClient) return;
  authClient.authStateManager.subscribe(onState);
  authClient.start();
  if (authClient.isLoginRedirect()) {
    await authClient.handleLoginRedirect();
    window.history.replaceState({}, document.title, "/");
  }
  await authClient.authStateManager.updateAuthState();
}

export async function signIn() {
  if (!authClient) return;
  authClient.setOriginalUri("/");
  await authClient.signInWithRedirect();
}

export async function signOut() {
  await authClient?.signOut({ postLogoutRedirectUri: window.location.origin });
}

export async function idToken() {
  const token = await authClient?.tokenManager.get("idToken");
  return token && "idToken" in token ? token.idToken : null;
}
